import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import { fromUnitsToRem, YodaFontSize, YodaFontWeight, YodaSpacing } from 'yoda-ui/yodaTheme';

export const adminDashboardTitleStyle: SxProps<Theme> = {
  height: '80px',
  fontWeight: YodaFontWeight.bold,
  fontSize: YodaFontSize.xLargePlus,
};

export const adminDashboardSummaryTitleStyle: SxProps<Theme> = {
  fontWeight: YodaFontWeight.bold,
  marginBottom: fromUnitsToRem(YodaSpacing.medium),
  fontSize: YodaFontSize.xLarge,
};

export const adminDashboardSummaryStatsStyle: SxProps<Theme> = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: fromUnitsToRem(YodaSpacing.small),

  '& > *': {
    flex: `1 1 calc(30% - ${fromUnitsToRem(YodaSpacing.large)})`,
  },
};

export const adminDashboardGridListStyle: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'stretch',
  gap: YodaSpacing.large,
  marginTop: YodaSpacing.large,

  '& > *': {
    width: '100%',
  },
};

export const adminDashboardChartsLoaderStyle: SxProps<Theme> = {
  marginTop: YodaSpacing.large,
  width: '100%',
  height: '400px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};
